var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartWrapper"},[_c('column-chart',{attrs:{"data":_vm.chartData,"colors":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }